export const APPLICATION_STATUS = {
  NEW: "New",
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  COMPLETED: "Completed",
  SOFT_APPROVED: "Soft approved",
  APPROVED: "Approved",
  INVOICE_COLLECTED: "Invoice collected",
  MANDATED: "Mandated",
  SIGNED: "Signed",
  DISBURSED: "Disbursed",
  REJECTED: "Rejected",
  PENDING_VERIFICATION: "Pending Verification",
  VERIFICATION_COMPLETE: "Verification Complete",
};

export enum PRODUCT_TYPES {
  BUSINESS_LOAN = "BUSINESS_LOAN",
  PERSONAL_LOAN = "PERSONAL_LOAN",
  CONSUMER_DURABLES_LOAN = "CONSUMER_DURABLES_LOAN",
  GROUP_LOAN = "GROUP_LOAN",
}

export const ProductType = {
  "Personal loan": PRODUCT_TYPES.PERSONAL_LOAN,
  "Business Loan": PRODUCT_TYPES.BUSINESS_LOAN,
  "Consumer durables loan": PRODUCT_TYPES.CONSUMER_DURABLES_LOAN,
  "Group Loan": PRODUCT_TYPES.GROUP_LOAN,
};

export function getProductTypeByValue(value: string): string | undefined {
  const entry = Object.entries(ProductType).find(([, val]) => val === value);
  return entry ? entry[0] : undefined;
}

export const getStatusColor = (status: string): string => {
  const colorMap: { [key: string]: string } = {
    DRAFT: "bg-gray-200 text-gray-800", // Draft – soft gray
    SUBMITTED: "bg-blue-200 text-blue-900", // Submitted – light blue
    SOFT_APPROVED: "bg-purple-200 text-purple-900", // Soft Approved – muted purple
    APPROVED: "bg-green-200 text-green-900", // Approved – gentle green
    INVOICE_COLLECTED: "bg-yellow-200 text-yellow-900", // Invoice Collected – light yellow
    MANDATED: "bg-teal-200 text-teal-900", // Mandated – calm teal
    SIGNED: "bg-indigo-200 text-indigo-900", // Signed – soft indigo
    REJECTED: "bg-red-200 text-red-900", // Rejected – clear red
  };

  return colorMap[status] || "bg-slate-100 text-slate-800"; // Default - neutral slate
};
